
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Бул
                    <a href="${0}">Folksonomy Engine долбоору</a>тарабынан келтирилген.
                    катышуудан же пикир билдирүүдөн тартынбаңыз`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Бул курал ингредиенттердин тизмесин оңдоого мүмкүндүк берет.
                ингредиенттердин тизмесин кошуп, алып салсаңыз же түзөтө аласыз.
                <br>
                Бул белги <span class="highlight">␣</span> боштукту билдирет.
                <br>
                Бул белги <span class="highlight">↩︎</span> саптын үзүлүшүн билдирет. `,
'hb28f1f2ec1744ee9': html`Бул касиеттер колдонуучулар тарабынан ар кандай колдонуу үчүн түзүлгөн жана берилген.
                    өзүңүздүн оюңузду кошуңуз. Сиз жараткан касиеттер жана баалуулуктар
                    <strong>фактылуу болушу керек</strong>. Сиз
                    <a href="${0}">коомчулук тарабынан мурунтан эле колдонулган касиеттердин тизмесине сүңгүп кирсеңиз болот</a>
                    же
                    <a href="${1}">касиеттеринин документтерин жана анын издөө системасын</a>изилдей аласыз.`,
's000a5b76bd3a01c2': `Мүлктөр жүктөлүүдө...`,
's000d98595e959c1e': `Google Play'ден жүктөп алыңыз`,
's013bdc8cf0d3583d': `Ингредиенттер үчүн бизге жардам бериңиз`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Түшүмдү ырастоо`,
's03e9c8114521b998': `Мен ингредиенттерди түзөтөм`,
's05ec315d9308091a': `Штрих-код бурчтарынын сөлөкөтү`,
's061eb5af92512c85': `Сакталды! Башкасына жардам бере аласызбы?`,
's06847c221c4c0bc1': `Мен [колдонуу жагдайыңызды сүрөттөп] үчүн мүлк түзгүм келет...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Топтолгон баалуулуктар`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `арналган документтер`,
's0bb2d48532acc455': `CSV жүктөп алыңыз`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Сүрөттү жараксыз кылуу`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Кесипти жокко чыгаруу`,
's11a18a69b30b65ed': `Ингредиенттер тизмесиндеги каталарды оңдоого жардам бериңиз`,
's1205d5f6fccf8e69': `Property Value`,
's15d64a0a6715285a': `Жаңы ачкыч`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Тандоо аймагы`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Тамактануу тууралуу маалыматты оңдоого жардам бериңиз`,
's1e00019dc454872d': `Properties-name атрибутун колдонуу менен менчиктин атын бериңиз.`,
's1e49126af0935a5b': `Бул мүлктү колдонгон өнүмдөрдүн тизмеси`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Мүлктү документтештирүү`,
's300b3a6ee4e1252d': str`Начар дал келүү ${0}%`,
's33f786bb6b4f0cf4': `Кесүү натыйжасы`,
's33f85f24c0f5f008': `Сактоо`,
's34be4af4e8fec4ae': `Адегенде коомчулуктан сура`,
's36d86adc823cbfa6': `Жаңы мүлктү түзүүдөн мурун, аны коомчулук менен талкуулаңыз:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `Кесүүнү баштапкы абалга келтирүү`,
's39bcf88721a1e8ee': `Тандоону баштапкы абалга келтирүү`,
's39e14e14300694c7': `Документтер жана көрсөтмөлөр`,
's3b430cfa5c1fe7f4': str`${0}үчүн документация`,
's3f4e4b52f230a892': `Сүрөт кенеп`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Мааниси`,
's422bba9636ce2489': `Борбордук сүрөт`,
's42dd66b2441566fd': `Борбордук сүрөтчө`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Аш болумдуу зат кошуңуз`,
's453ab0dbb9b5c777': `Өлчөмүн оңго өзгөртүү`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Продукт саны`,
's4df2f533c0c1e7d0': `Сүрөттү башкаруу`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Тандоону жылдыруу`,
's4f751fb9b3ed766c': `Жаңы мүлктү түзүү`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Менчик атын киргизиңиз...`,
's55d7249883a98ca1': `Open Food Facts викиде бул мүлк жөнүндө`,
's565867d84c04aea2': `Чыпкалоо касиеттери...`,
's5666afe5cd0166de': `Ырастоодон мурун каталарды оңдоңуз же текстти өзгөртүңүз`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Товарлар жүктөлүүдө...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Тамактануу тууралуу маалыматты оңдоого жардам бериңиз.`,
's5dd6f12783fca34f': `Ингредиенттердин тизмесин түзөтүү`,
's5e8250fb85d64c23': `Жабуу`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Оңдоо`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Кесилген сүрөт`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Жакшы дал келүү ${0}%`,
's71a5c9f4b68ef4d4': `Эсептөө`,
's74cb3d66f6a668e1': `Документация`,
's787dd11bed0dc88a': `Өлчөмүн солго өзгөртүү`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Кыймылсыз мүлк түзүү жана көрсөтмөлөр жөнүндө көбүрөөк билүү:`,
's8038273de2cf8b73': `Сураныч, кесүү үчүн аймакты тандаңыз.`,
's839cc2908a5387f2': `Штрихкоддорду чыпкалоо...`,
's86197dcf3e96af64': `Учурдагы касиеттерди карап чыгуу жана издөө`,
's8a63be30a129a59c': `Төмөнкү өлчөмүн өзгөртүү`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Өлчөмүн өзгөртүү жогорку оң`,
's8db84aa4bc949af2': `Жаңы мүлктү документтештирүү`,
's8f839a03997a16d7': `Продукт көрүү`,
's901ae1e236ac45d3': `Жок кылууну жокко чыгаруу`,
's907f7a97c6b29425': `Маалымат модели өзгөртүлүшү мүмкүн экенин эске алыңыз. Өзүңүздүн тобокелиңиз менен колдонуңуз.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ингредиенттер:`,
's9a7f60fce090ecaf': `касиеттери жүктөлгөн жок. Сураныч, кийинчерээк кайра аракет кылыңыз.`,
's9b87abd68fb9df45': `Табылган жок? Жаңы ачкыч түзүү {value}`,
's9c0f52425fd2f07e': `Дал келбеши мүмкүн`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Упай жок`,
'sa548778b24054030': `Folksonomy Engine долбоорунан бардык салым кошкон касиеттерди изилдеңиз. Бул касиеттер Open Food Facts маалымат базасындагы азыктар жөнүндө кошумча метадайындарды жана түшүнүктөрдү берет.`,
'sa63907958bd0ec4b': `Өлчөмүн өзгөртүү жогорку сол`,
'sa95b4224f685a36a': `Модалды жабуу`,
'sab56a1d439576fd6': `Сунуш сүрөтчөсү`,
'sac47ea2901d04c15': `Өлчөмүн өзгөртүү төмөнкү сол`,
'sb125227d436c2925': `Учурдагы касиеттер базасынан мүлк концепцияңызды издеңиз:`,
'sb125568d43642e6f': `Продукт тууралуу суроолорго жооп бериңиз.`,
'sb1c538e038f9b214': str`Абдан жакшы дал келген ${0}%`,
'sb28639570ff3b852': `бардык мүлктөрдүн тизмеси`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Менчигиңиз жок экенин жана коомчулук анын пайдалуу экенин ырастагандан кийин, адегенде аны викиде документтештирүү керек.`,
'sb3d4f79d9d8b71e5': `Урастоо`,
'sb560fa37a7bfb6c2': `Бул мүлк үчүн эч кандай продукт табылган жок.`,
'sb7f72e4c8a2d3357': `Маанилерди чыпкалоо...`,
'sb8178320160f84ea': `Өсүмдүк көрсөтүү`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Бардык түшүнүктөр жооп берилди! Жардамыңыз үчүн рахмат!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Тиешелүү маани`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Өлчөмүн өзгөртүү`,
'sc1c08d0cbcc3bd24': `Дал келбейт`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Сунушталган оңдоо`,
'sc681b137e8f604f7': `Өчүрүүнү ырастоо`,
'sc6daf8a31883f8b9': `Сүрөттү жылдыруу`,
'sc895972c88d38ca5': `Фольксономиялык касиет`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Катарлар`,
'scb3b0671d7b7f640': `Жаңы маани`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slack талкуусуна кошулуңуз`,
'scdb6cad0b92721bf': `Мүлк табылган жок.`,
'scf23a05631f93732': `Жок кылууну ырастоо`,
'scfed2f270ef6a3aa': `аймакты тандоо`,
'sd1022bc1ef9204f7': `Чоңойтуучу сүрөт`,
'sd1077c055cf9ba6b': `Буюмдун ингредиенттеринин тизмесин текшерүүгө жардам бериңиз.`,
'sd698d21ddecba56b': `Эй! Төмөнкү бөлүктөргө жооп берип, продукт маалыматын жакшыртууга жардам бере аласыз:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Менчик мурунтан эле бар экенин текшериңиз`,
'sdbf806fefc584115': `а табыш керек`,
'sdc673e73b5c13aea': `Өчүрүү`,
'sdc792b75f1edcaba': `Бизге ингредиенттердин жазылышын оңдоого жардам бериңиз.`,
'sdca5deead576ceee': `Төмөнкү оң жагындагы өлчөмүн өзгөртүү`,
'sdcc2555c5dde524f': `Бул нерсени чын эле жок кылгыңыз келеби? Бул аракетти артка кайтаруу мүмкүн эмес.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Жарамсыз кылуу`,
'se5127cf0f92e7e48': `Кеңеш: сиз да таба аласыз`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Мен жакшыраак түшүмдү сунуш кылам`,
'seea3800e27baa686': `Жеке продуктылар`,
'sefaba4adc4ec9219': `Folksonomy касиеттери`,
'seffa8ca49175b5f0': `Жекелештирилген касиеттер`,
'sf44a6b3b232c28ea': str`Учурдагы маанини ${0}менен алмаштырыңыз`,
'sf4cd86a2f5ef2588': `Продукт штрих коду`,
'sf57a61152168cc81': `Ингредиентти аныктоону оңдоого жардам бериңиз`,
'sf88b90b8ba23871c': `Белгисиз дал келүү`,
'sf9aee319a006c9b4': `Кошуу`,
'sfacbbe968fa7d773': `Кыймыл аты:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Тиешелүү маани`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  